'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tooltip(props) {
  var RootType = props.component || 'div';

  return _react2.default.createElement(
    RootType,
    { className: _style2.default.hintTop, 'aria-label': props.title },
    props.children
  );
} /*
   * Copyright 2016 hudl
   * All rights reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *    http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *
   * @providesModule Tooltip
   * 
   */

Tooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  title: _propTypes2.default.string.isRequired,
  component: _propTypes2.default.string
};
module.exports = exports['default'];